<!--
 * @Author: DQL
 * @Date: 2020-03-18 10:31:26
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 10:35:57
 * @Description: 机构管理--编辑机构信息
 -->
<template>
  <div
    class="l-page--inner l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        修改
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="handleClickSwitchToView()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <hm-page-card
        class="c-card--detail"
      >
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          label-position="right"
          label-width="160px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              v-if="deptVo.parentDeptCode && deptVo.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织代码"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.parentDeptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="deptVo.parentDeptName"
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="上级组织名称"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.parentDeptName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织代码"
                prop="deptCode"
              >
                <span
                  class="c-form__read"
                >
                  {{ deptVo.deptCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织名称"
                prop="deptName"
              >
                <el-input
                  v-model.trim="fd.deptName"
                  class="c-form__input"
                  placeholder="组织名称"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织简称"
                prop="deptShortName"
              >
                <el-input
                  v-model.trim="fd.deptShortName"
                  class="c-form__input"
                  placeholder="组织简称"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织标志"
                prop="deptTypeCode"
              >
                <el-radio-group
                  v-model="fd.deptTypeCode"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="(value,key) in deptType"
                    :key="key"
                    :label="value.id"
                  >
                    {{ value.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="选用标志"
                prop="isUseCode"
              >
                <el-radio-group
                  v-model="fd.isUseCode"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="(value,key) in isUseType"
                    :key="key"
                    :label="value.id"
                  >
                    {{ value.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="有效期起"
                prop="effectStartDate"
              >
                <el-date-picker
                  v-model="fd.effectStartDate"
                  class="c-form__date"
                  type="date"
                  value-format="timestamp"
                  placeholder="有效期起"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="有效期止"
                prop="effectEndDate"
              >
                <el-date-picker
                  v-model="fd.effectEndDate"
                  class="c-form__date"
                  type="date"
                  value-format="timestamp"
                  placeholder="有效期止"
                />
              </el-form-item>
            </el-col> -->
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="组织级次"
                prop="deptLevelType"
              >
                <el-radio-group
                  v-model="fd.deptLevelType"
                  class="c-form__radio-group"
                >
                  <el-radio
                    v-for="(value,key) in deptLevelType"
                    :key="key"
                    :label="value.id"
                  >
                    {{ value.text }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="地址"
                prop="deptAddress"
              >
                <el-input
                  v-model.trim="fd.deptAddress"
                  class="c-form__input"
                  placeholder="地址"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="tel"
              >
                <el-input
                  v-model.trim="fd.tel"
                  class="c-form__input"
                  placeholder="联系电话"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="传真"
                prop="fax"
              >
                <el-input
                  v-model.trim="fd.fax"
                  class="c-form__input"
                  placeholder="传真"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="电子邮箱"
                prop="email"
              >
                <el-input
                  v-model.trim="fd.email"
                  class="c-form__input"
                  placeholder="电子邮箱"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="邮政编码"
                prop="postCode"
              >
                <el-input
                  v-model.trim="fd.postCode"
                  class="c-form__input"
                  placeholder="邮政编码"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <!-- 页面主内容：详情 End -->
  </div>
</template>

<script>
import _ from 'lodash';
import { deptService } from './dept.service';

export default {
  name: 'EditDept',
  props: {
    deptVo: {
      type: Object,
      default () {
        return {
          parentDeptCode: null,
          parentDeptName: null,
          deptCode: null,
          deptName: null,
          deptShortName: null,
          deptTypeCode: null,
          effectStartDate: null,
          effectEndDate: null,
          source: null
        };
      }
    },
    isLoading: {
      type: Boolean
    },
    canNotLeavePage: {
      type: Boolean
    }
  },
  data () {
    return {
      /* 表单参数 Start */
      fd: {
        parentDeptCode: null,
        parentDeptName: null,
        deptCode: null,
        deptName: null,
        deptShortName: null,
        deptType: '1',
        deptTypeCode: '1',
        effectStartDate: null,
        effectEndDate: null
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        deptName: [
          this.$validUtils.required('组织名称'),
          this.$HMValidator.maxLength('组织名称', 100)
        ],
        deptShortName: [
          this.$HMValidator.maxLength('组织简称', 50)
        ],
        deptTypeCode: [
          this.$validUtils.required('组织标志')
        ],
        email: [
          this.$HMValidator.email('电子邮箱')
        ],
        postcode: [
          this.$HMValidator.postcode('邮政编码')
        ],
        effectStartDate: [
          this.$validUtils.required('有效期起'),
          this.$HMValidator.startTime(this, 'fd', 'effectEndDate', ['有效期起', '有效期止'])
        ],
        effectEndDate: [
          this.$validUtils.required('有效期止'),
          this.$HMValidator.endTime(this, 'fd', 'effectStartDate', ['有效期起', '有效期止'])
        ],
        isUseCode: [
          this.$validUtils.required('选用标志')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  computed: {
    // 部门类型
    deptType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_TYPE) {
        return enums.DEPT_TYPE;
      }
      return {};
    },
    // 选用标志
    isUseType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.BASE_ENABLE_TYPE) {
        return enums.BASE_ENABLE_TYPE;
      }
      return {};
    },
    // 机构级次
    deptLevelType () {
      const enums = this.$HMStoreService.getEnums();
      if (enums && enums.DEPT_LEVEL) {
        return enums.DEPT_LEVEL;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        console.log(_this.$refs.fd);
        if (valid) {
          // 回调页面开启loading状态
          _this.$emit('update:isLoading', true);
          deptService.update(_this.fd)
            .then(rsp => {
              _this.$alert('更新成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              // 回调页面重载
              _this.$emit('reloadView', _this.deptVo.deptCode);
            })
            .catch(err => {
              // 回调页面关闭loading状态
              _this.$emit('update:isLoading', false);
              console.error('机构部门编辑保存失败', err);
            });
        }
      });
    },
    /**
     * @description: 触发切换页面状态为查看菜单
     * @param {*}
     * @return {*}
     */
    handleClickSwitchToView () {
      this.$emit('switch', 'viewDept');
    }
  },
  watch: {
    // 深度监听表单
    fd: {
      handler (newVal, oldVal) {
        if (oldVal.deptCode) {
          this.$emit('update:canNotLeavePage', true);
        }
      },
      deep: true
    }

  },
  created () {
    this.fd = _.clone(this.deptVo);
  }
};
</script>
